import { AuthMethod } from "./types";
import { cn } from "@/lib/utils";

type AuthMethodSelectorProps = {
  methods: AuthMethod[];
  selectedMethod: AuthMethod | null;
  onSelect: (method: AuthMethod) => void;
  isDisabled?: boolean;
};

const AUTH_METHOD_LABELS: Record<AuthMethod, string> = {
  apiKey: "API Key",
  oauth: "OAuth",
  token: "Token",
  companyCodeProjectCode: "Company Code + Project Code",
  urlMethodTokens: "URL + Tokens por método",
};

const AuthMethodSelector = ({
  methods,
  selectedMethod,
  onSelect,
  isDisabled = false,
}: AuthMethodSelectorProps): JSX.Element => {
  return (
    <div className="flex flex-row gap-3">
      {methods.map((method) => (
        <button
          key={method}
          type="button"
          className={cn(
            "rounded-md border-2 px-4 py-3 text-sm transition-all",
            selectedMethod === method
              ? "border-purple-500 bg-purple-50 font-semibold text-purple-700"
              : "border-gray-200 bg-white font-normal text-gray-700",
            isDisabled
              ? "cursor-not-allowed opacity-60"
              : selectedMethod === method
                ? "hover:border-purple-500 hover:bg-purple-50"
                : "hover:border-gray-300 hover:bg-gray-50"
          )}
          onClick={() => !isDisabled && onSelect(method)}
        >
          {AUTH_METHOD_LABELS[method]}
        </button>
      ))}
    </div>
  );
};

export default AuthMethodSelector;
